import React from 'react'
import imgLogoBlack from '../../assets/Presskit/Bestia-Logo/Bestia.png'

export const Sliderinfinite = () => {
  return (

    <div className='slider-bestia'>

      <div className='slide-track-bestia'>

        <div className='slide-bestia'>
            <img src={imgLogoBlack} alt="" className='slide-img-bestia' />
            <p>#SomosBESTIAS</p>
            <span>😈</span>
        </div>

        <div className='slide-bestia'>
            <img src={imgLogoBlack} alt="" className='slide-img-bestia' />
            <p>#SomosBESTIAS</p>
            <span>😈</span>
        </div>
        <div className='slide-bestia'>
            <img src={imgLogoBlack} alt="" className='slide-img-bestia' />
            <p>#SomosBESTIAS</p>
            <span>😈</span>
        </div>
        <div className='slide-bestia'>
            <img src={imgLogoBlack} alt="" className='slide-img-bestia' />
            <p>#SomosBESTIAS</p>
            <span>😈</span>
        </div>
        <div className='slide-bestia'>
            <img src={imgLogoBlack} alt="" className='slide-img-bestia' />
            <p>#SomosBESTIAS</p>
            <span>😈</span>
        </div>
        <div className='slide-bestia'>
            <img src={imgLogoBlack} alt="" className='slide-img-bestia' />
            <p>#SomosBESTIAS</p>
            <span>😈</span>
        </div>
        <div className='slide-bestia'>
            <img src={imgLogoBlack} alt="" className='slide-img-bestia' />
            <p>#SomosBESTIAS</p>
            <span>😈</span>
        </div>
        <div className='slide-bestia'>
            <img src={imgLogoBlack} alt="" className='slide-img-bestia' />
            <p>#SomosBESTIAS</p>
            <span>😈</span>
        </div>
        <div className='slide-bestia'>
            <img src={imgLogoBlack} alt="" className='slide-img-bestia' />
            <p>#SomosBESTIAS</p>
            <span>😈</span>
        </div>
        <div className='slide-bestia'>
            <img src={imgLogoBlack} alt="" className='slide-img-bestia' />
            <p>#SomosBESTIAS</p>
            <span>😈</span>
        </div>
      </div>

    </div>

  )
}
